<template>
  <form @submit.prevent="onSubmitForm">
    <vs-input
      label="Номер чека"
      class="w-full"
      v-model="number"
    />
    <div class="mt-4 text-center">
      <vs-button button="submit" type="border" color="success">
        Сохранить
      </vs-button>
    </div>
    <div v-if="loading" class="block-loading-container">
      <div class="block-loading"></div>
    </div>
  </form>
</template>

<script>
import modalContext from "@/mixins/modalContext";

export default {
  name:   "SetCheckNumberPopup",
  mixins: [modalContext],
  props:  ['onSubmit'],
  data() {
    return {
      loading: false,
      number:  '',
    };
  },
  methods: {
    onSubmitForm() {
      if (!this.number) return;

      this.loading = true;
      this.onSubmit({ number: this.number }).then(
        () => {
          this.modalResolve();
        },
        () => {
          this.loading = false;
        },
      );
    },
  },
};
</script>

<style lang="scss" module>

</style>
